export default __webpack_public_path__ + "static/media/step-4.ac132ca4.jpeg";